// extracted by mini-css-extract-plugin
export default {"grid":"grid__ActivityViewerTopBar__VLN3K","title":"title__ActivityViewerTopBar__VLN3K"};